module.exports = __webpack_public_path__ + "static/media/sombrero (1).80785d75.png";